<template>
    <div>
        <vue-headful :title="'Products Level History - AMOS365'" />

        <h4 class="page-header">
            Product Level History Report
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="productsTable" url="/products/levels/history" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <button class="btn btn-sm btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                            <i class="fas fa-ban"></i>
                        </button>
                        <button class="btn btn-sm btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                            <i class="fas fa-filter"></i>
                            <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                        </button>
                        <button class="btn btn-sm btn-default" v-on:click="exportTable()" title="Clear All Filters" :disabled="exportingTable || loadingHistory">
                            <template v-if="exportingTable">
                                <i class="fa fa-spin fa-spinner"></i> Exporting
                            </template>
                            <template v-else>
                                <i class="fa fa-file-excel"></i> Export
                            </template>
                        </button>
                        <div class="d-inline-block" v-if="loadingHistory">
                            <i class="fa fa-spin fa-spinner"></i> Fetching History
                        </div>
                    </div>

                    <template slot="last_name" slot-scope="props">
                        {{ props.row.last_name }}, {{ props.row.first_name }}
                    </template>

                    <template slot="created_at" slot-scope="props">
                        <span v-if="props.row.created_at">{{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                    </template>
                </v-server-table>
            </div>
        </div>

        <b-modal v-model="showFilters" :ref="'productListFilters'" title="Agent Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()" :static="true">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Product Type:</div>
                <div class="col-md-7 col-12">
                    <v-select v-model="filters['products.product_type_id']" :options="productTypes" :reduce="type => type.id" label="product_type_name" placeholder="-- Select a Product Type --" multiple />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Date of Change:</div>
                <div class="col-md-7 col-12">
                    <date-filter :filter="filters['history.created_at']" size="sm" />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                exportingTable: false,
                showFilters: false,
                loadFilters: true,
                loadingHistory: false,
                historyCount: null,
                userTimezone: this.$root.timezone,
                productTypes: [],

                columns: ['product_name', 'writing_nbr', 'seller_name', 'seller_npn', 'old_value', 'new_value', 'created_at', 'user_name'],
                options: {
                    headings: {
                        product_name: 'Product',
                        writing_nbr: 'Writing#',
                        seller_name: 'Seller',
                        seller_npn: 'NPN',
                        old_value: 'Previous Value',
                        new_value: 'New Value',
                        created_at: 'Date Of Change',
                        user_name: 'Changed By',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'history.created_at',
                    },
                    texts:{
                        filterPlaceholder:"Search Product Level History",
                    },
                    responseAdapter: (response) => {
                        //SHow Loading
                        this.loadingHistory = false;

                        //Set the count
                        this.historyCount = response.data.count;

                        //Check for filters
                        if(response.data.filters)
                        {
                            //Set the filters
                            this.setFilters(response.data.filters);
                        }

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //SHow Loading
                        this.loadingHistory = true;

                        //Load the Filters
                        if(this.loadFilters)
                        {
                            //Append it
                            data.load_filters = true;

                            //Cancel it
                            this.loadFilters = false;
                        }

                        //Add the type
                        data.filters = this.filters;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'products.product_type_id': [],
                    'history.created_at': {
                        'logic': null,
                        'value': null,
                        'value2': null,
                    },
                },
            }
        },

        watch: {

        },

        computed: {

            canEdit(){
                //Check Permissions
                return this.$root.hasPermission(['products.manage']);
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(typeof this.filters[keys[i]] === 'object' && !Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]] !== null)
                    {
                        //Check the Logic
                        if(this.filters[keys[i]]['logic'] != null)
                        {
                            count++;
                        }
                    }
                    else if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            setFilters(data){
                //Set all
                this.productTypes = data.productTypes;
            },

            applyFilters(){
                //Apply the filters
                this.$refs.productsTable.refresh();
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(typeof this.filters[keys[i]] === 'object' && !Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]] !== null)
                    {
                        this.filters[keys[i]] = {
                            'logic': null,
                            'value': null,
                            'value2': null,
                        };
                    }
                    else if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.productsTable.refresh();
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.productsTable.columns));

                //Build the payload
                var payload = {
                    //filters: filters,
                    query: (this.$refs.productsTable.getRequestParams()).query,
                    orderBy: this.$refs.productsTable.options.orderBy.column,
                    ascending: this.$refs.productsTable.options.orderBy.ascending,
                    table: 'productsTable',
                    columns: cols,
                    export: true,
                };

                //Send it
                this.$http.get('/products/levels/history', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.productsTable.$refs.genericFilter.focus();
        }
    }
</script>
